export default __webpack_public_path__ + "static/media/select-features.28cec313.png";